
import { ActionTypes } from '@/store/actionTypes';
import { mapGetters } from 'vuex';
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import { isNullOrUndefined } from '@/shared/helpers';
import { defineComponent } from 'vue';
import apmTransactions from '@/libraries/apm/transactions';

export default defineComponent({
    name: 'SomethingWrongOverlay',
    components: {
        ConfirmationOverlay,
    },
    props: {
        message: String,
        customBackFunc: {
            type: Function,
            required: false,
            default: null,
        },
    },
    created() {
        console.error('Error: ', this.message);
    },
    mounted() {
        apmTransactions.instrumentUnhandledError(this.error?.message);
    },
    computed: {
        ...mapGetters({
            error: 'getError',
        }),
    },
    methods: {
        navigateBack() {
            if (!isNullOrUndefined(this.customBackFunc)) {
                this.customBackFunc();
            } else {
                this.$store.dispatch(ActionTypes.CLEAR_ERROR, undefined);
                this.$router.back();
            }
        },
    },
});
